import { render, staticRenderFns } from "./BrTimeDistributionTable.vue?vue&type=template&id=6152f438&scoped=true"
import script from "./BrTimeDistributionTable.vue?vue&type=script&lang=js"
export * from "./BrTimeDistributionTable.vue?vue&type=script&lang=js"
import style0 from "./BrTimeDistributionTable.vue?vue&type=style&index=0&id=6152f438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152f438",
  null
  
)

export default component.exports